export const REACT_APP_VAM_SAML = process.env.REACT_APP_VAM_SAML
export const REACT_APP_VAM_SAML_OMDC = process.env.REACT_APP_VAM_SAML_OMDC
export const REACT_APP_VAM_ENDPOINT = process.env.REACT_APP_VAM_ENDPOINT
export const REACT_APP_KSHEMA_POC2=`${process.env.REACT_APP_KSHEMA_URL}/v1`
export const REACT_APP_KSHEMA_POC1=process.env.REACT_APP_KSHEMA_URL
export const REACT_APP_KSHEMA_V2=process.env.REACT_APP_KSHEMA_URL_V2
export const CLIENT_ID=process.env.REACT_APP_CMS_CLIENT_ID
export const CLIENT_ID_OMDC=process.env.REACT_APP_OMDC_CLIENT_ID
export const token_ID = process.env.REACT_APP_CMS_TENANT_ID
export const token_ID_OMDC = process.env.REACT_APP_OMDC_TENANT_ID
export const tokenClientSecret= process.env.REACT_APP_CMS_SECRET
export const tokenScope=process.env.REACT_APP_CMS_SCOPE
export const survey_image_base_url = process.env.REACT_APP_SURVEY_IMAGE_BASE_URL
export const redirectURI = process.env.REACT_APP_REDIRECT_URI
export const KSHEMA_1_URL = process.env.REACT_APP_KSHEMA_1_URL
export const KSHEMA_ENDORSEMENT = process.env.REACT_APP_KSHEMA_ENDORSEMENT
export const KSHEMA_OLD_DOCUMENTS_URL = process.env.REACT_APP_OLD_DOCUMENTS_URL
//Below lists are context text for each module

export const WRAPPER_SERVICE = `${REACT_APP_KSHEMA_V2}/wrapper-api-service/api/v2`
export const COMMON_UTIL_SERVICE = `${REACT_APP_KSHEMA_V2}/common-util-service/v1`
export const FILE_MANAGEMENT_SERVICE = `${REACT_APP_KSHEMA_V2}/file-management-service/v1/`
export const QUOTATION_MANAGEMENT_SERVICE = `${REACT_APP_KSHEMA_V2}/quotation-management-service/api/v1`
export const AUDIT_SERVICE = "/kauditservice/api/v1";
export const CALCULATION_SERVICE = "kcalculationservice/api/v1";
export const FIELD_SURVEY_SERVICE = "kfieldsurveyservice/api/v1";
export const GIS_CMS_SERVICE = "giscms";
export const REACT_APP_VAM_CONTEXT_CALCULATE = `${CALCULATION_SERVICE}/CalculationService`;
export const NOTIFICATION_SERVICE = "knotificationservice/api/v1/notificationService"
export const CLAIM_INGESTION_SERVICE = "kclaimingestion/api/v1"
export const REACT_APP_VAM_CONTEXT_INGESTION = `${CLAIM_INGESTION_SERVICE}/claimIngestion`;
export const REACT_APP_VAM_CONTEXT_DOCUMENT = "kdocumentservice/api/v1/document";
export const REACT_APP_VAM_CONTEXT_FIELD = `${FIELD_SURVEY_SERVICE}/FieldSurveyService`;
export const REACT_APP_VAM_CONTEXT_GIS = "kgissurveyservice/api/v1/GISSurveyService";
export const REACT_APP_VAM_CONTEXT_SURVEYOR = "ksurveyorandqcmasterservice/api/v1/SurveyorAndQCMasterService";
export const REACT_APP_VAM_CONTEXT_VENDOR = "kvendormasterservice/api/v1/VendorMasterService";
export const REACT_APP_VAM_CONTEXT_ROLE_MANAGMENT = "kuserrolemanagment/api/v1";
export const REACT_APP_VAM_CONTEXT_QC = "kqcservice/api/v1/qcProcess";
export const REACT_APP_VAM_CONTEXT_LITIGATION = "kmoreoptionsservice/api/v1/MoreOptionsService";
export const REACT_APP_VAM_CONTEXT_PAYMENT = "kpaymentservice/api/v1/PaymentService";
export const REACT_APP_VAM_CONTEXT_AUTHORIZATION = "kauthorizationservice/kshema/authentication/v1";
export const REACT_APP_VAM_CONTEXT_APPROVAL = "kbatchapprovalservice/api/v1/BatchApproval";
export const REACT_APP_VAM_CONTEXT_PAYMENT_UPLOAD = "kpaymentuploadservice/api/v1/paymentuploadservice";
export const REACT_APP_VAM_CONTEXT_MASTER = "kmasterservice/api/v1/MasterService";
export const REACT_APP_VAM_CONTEXT_INDEMNITY = `${REACT_APP_VAM_CONTEXT_MASTER}/indemnity`;
export const REACT_APP_VAM_CONTEXT_COMPENSATION = `${REACT_APP_VAM_CONTEXT_MASTER}/compensation`;
export const REACT_APP_VAM_CONTEXT_EXCESS = `${REACT_APP_VAM_CONTEXT_MASTER}/excess`;
export const REACT_APP_IMAGE_GEO_TAG = process.env.REACT_APP_IMAGE_GEO_TAG;
export const REACT_APP_VAM_CONTEXT_MASTER_ANIMAL_ATTACK = `${REACT_APP_VAM_CONTEXT_MASTER}/animal-attack`;
export const REACT_APP_VAM_CONTEXT_MASTER_LOSS_RESERVE = `${REACT_APP_VAM_CONTEXT_MASTER}/loss-reserve`;
export const REACT_APP_VAM_CONTEXT_PHOTO_COORDINATE = "kgissurveyservice/api/v1/GISSurveyService/photo-coordinates";
export const REACT_APP_SAW_CCE_SEARCH = "api/ncip/v1/saw/cce/search";
export const REACT_APP_IU_NAMES = "api/ncip/v1/saw/cce/iu-master";
export const REACT_APP_IMAGE_GEO_TAG_CLAIM = process.env.REACT_APP_IMAGE_GEO_TAG_CLAIM;
export const REACT_APP_CUSTOMER_ENDORSEMENT_INFORMATION_SHEET= "azure-file-service/v1.1";
export const REACT_APP_PROPOSAL_CKYC_LAND_FORM ="ops-azure-file-service/v1.1/"

//HEALTH
export const HEALTH_MASTER_SERVICE = "kmasterservice/api/v1/MasterService/health";
export const REACT_APP_HEALTH_CLAIM_INGESTION_ENDPOINT = "kclaimingestion/api/v1";
export const HEALTH_CLAIM_INGESTION = `${REACT_APP_HEALTH_CLAIM_INGESTION_ENDPOINT}/claim/health`
export const HEALTH_CALCULATION_SERVICE='kcalculationservice/api/v1/health/calculation'
export const HEALTH_PAYMENT_SERVICE='kpaymentservice/api/v1/central/payment-service'
export const COVERAGE_TYPES = "coverage-types"
export const HOSPITALIZATION_REASONS="hospitalization-reasons"
export const DOCUMENT_TYPES = "documents"
export const RELATIONS = "relations"
export const AILMENT_LIST = "ailments"
export const GENERATE_CLAIM = "generate"
export const DOC_BULK_UPLOAD = "bulk-upload"
export const HEALTH_CLAIM_PROCESSING_SEARCH = `${HEALTH_CLAIM_INGESTION}/search`
export const HEALTH_CLAIM_HISTORY = "history"
export const REACT_APP_HEALTH_REQUEST_INVESTIGATION = `${REACT_APP_HEALTH_CLAIM_INGESTION_ENDPOINT}/claims/investigation`;
export const REACT_APP_HEALTH_MEDICAL_REQUEST_INVESTIGATIONS = `${REACT_APP_HEALTH_CLAIM_INGESTION_ENDPOINT}/claims/investigations`;
export const HEALTH_CLAIM_STATUS_LIST = "status-list";